const getAppliedRangeMax = appliedRange => {
  return appliedRange && appliedRange.max;
};

const getRangeMax = range => {
  return range && range.max;
};

const getMax = (appliedRange, range) => {
  const appliedRangeMax = getAppliedRangeMax(appliedRange);
  const rangeMax = getRangeMax(range);
  return appliedRangeMax || rangeMax;
};

const getMaxValue = (max, increment) => { 
  const remainder = max % increment;
  return max + (remainder === 0 ? 0 : increment - remainder); 
};

const roundMaxPriceToNextIncrement = (appliedRange, range, increment) => {
  const max = getMax(appliedRange, range);
  const maxValue = getMaxValue(max, increment);
  return maxValue;
};

export default roundMaxPriceToNextIncrement;